'use strict';/* global define */define('modules/core/modules/app/services/airbrake/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["AIRBRAKE_KEYS", "AirbrakeJS", "Environment"];
function factory(AIRBRAKE_KEYS,AirbrakeJS,Environment){// jshint validthis:true
// jshint latedef:false
var airbrake;var HOST_FILTER_REGEX=/(loopline-systems\.com|helen\.dev)/;return{get:get};// ---
/**
     * Get airbrake Client or create a new one
     * if it doesn't exist yet
     *
     * @return {Object|null} airbrake client
     */function get(){if(typeof airbrake==='undefined'){airbrake=_getAirbreak();}return airbrake;}/**
     * Get airbrake client
     *
     * depending on following facts
     * - is AirbrakeJS available
     * - was the environment already set by a returning API response
     *   -> we need to set the correct keys for that
     *
     * @return {Object|null} airbrake client
     */function _getAirbreak(){var airbrake;if(!AirbrakeJS){return null;}if(!!Environment.get()){var keys=Environment.isProduction()?AIRBRAKE_KEYS.PRODUCTION:AIRBRAKE_KEYS.DEVELOPMENT;airbrake=new AirbrakeJS.Client({projectId:keys.PROJECT_ID,projectKey:keys.API_KEY});airbrake.addFilter(function(notice){// checking for errors without stack trace
if(!notice.errors[0].backtrace[0]){return notice;}// checking for errors caused by our scripts, including dev env
if(HOST_FILTER_REGEX.test(notice.errors[0].backtrace[0].file)){return notice;}return null;});}return airbrake;}}module.exports=factory;});
